import {
  autoLogIn,
  changePassword,
  forgotPassword,
  forgotPasswordSubmit,
  resend_verification,
  signIn,
  signOut,
  signUp,
  verification,
  newPassword,
  mapUserInfo,
  signInGoogle,
} from "../../services/auth/auth.service";
import Const from "../consts";
import { toast } from "react-toastify";
import { WelcomeMessage } from "../helper/welcome.helper";
import { progressAction } from "../helper/action.helper";
import { ac_app_loading, ac_get_account } from "./account.action";
import { URL_PATHS } from "../../consts/url.paths.consts";
import navigationService from "../../services/navigation/navigation.service";

export const ac_login =
  (user: string, password: string) => async (dispatch: any, getState: any) => {
    try {
      const response: any = await signIn(user, password);
      if (response.challengeName === "PASSWORD_RESET_REQUIRED") {
        dispatch({ type: Const.UN_AUTHORISE, payload: {} });
        toast("Please reset your password to finish updating your account.");
        await dispatch(ac_forgot_password(user, true));
        return;
      }


      if (response.challengeName === "NEW_PASSWORD_REQUIRED") {
        toast.warn("Please enter a new password!");
        navigationService.navigate("/new-password");

        dispatch({
          type: Const.UN_AUTHORISE,
          payload: { tempSession: response },
        });

        return;
      }

      if (!response.attributes.email_verified) {
        await signOut();
        throw new Error("User is not confirmed.");
      }

      dispatch(ac_get_account());
      const userInfo = mapUserInfo(response, null);
      dispatch({
        type: Const.AUTHORISE,
        payload: userInfo,
      });

      toast.success(`${WelcomeMessage()} ${response.attributes.email}!`);
    } catch (e) {
      if (e && typeof e === "string") {
        toast.error(e);
        return
      }
      if (e.message && e.message.includes("User is not confirmed.")) {
        toast.warn("Please confirm your email!");
        resend_verification(user)
          .then((res) => {
            navigationService.navigate(URL_PATHS.ACTIVE_ACCOUNT, { userName: user, password: password });
          })
          .catch((e) => {
            toast.error(e.message);
          });

        return;
      }
      toast.error(e.message);
      dispatch({
        type: Const.UN_AUTHORISE,
        payload: {},
      });
    }
  };
export const ac_login_google = () => async (dispatch: any, getState: any) => {
  try {
    //const response: any =
    await signInGoogle();

    // dispatch(ac_get_account());
    // const userInfo = mapUserInfo(response);
    // dispatch({
    //   type: Const.AUTHORISE,
    //   payload: userInfo,
    // });

    // toast.success(`${WelcomeMessage()} ${response.attributes.email}!`);
  } catch (e) {
    // if (e.message.includes("User is not confirmed.")) {
    //   toast.warn("Please confirm your email!");
    //   resend_verification(user)
    //     .then((res) => {
    //       dispatch(
    //         ac_redirect({
    //           to: "/activate",
    //           userName: user,
    //           password: password,
    //         })
    //       );
    //     })
    //     .catch((e) => {
    //       toast.error(e.message);
    //     });

    //   return;
    // }
    toast.error(e.message);
    dispatch({
      type: Const.UN_AUTHORISE,
      payload: {},
    });
  }
};

export const ac_signup =
  (user, password, customAttr) => async (dispatch: any, getState: any) => {
    try {
      const response: any = await signUp(user, password, customAttr);
      navigationService.navigate("/activate", { userName: user, password: process.env.REACT_APP_AUTH_MODE !== "cognito" ? undefined : password });
      return response;
    } catch (e) {
      toast.error(e.message);
    }
  };

export const ac_verify =
  (userName: string, activationCode: string, password?: string) =>
  async (dispatch: any, getState: any) => {
    try {
      const response: any = await verification(userName, activationCode);
      toast("The account has been verified successfully");

      if (password) {
        dispatch(ac_login(userName, password));
        navigationService.navigate("/");
      } else {
        navigationService.navigate(URL_PATHS.LOGIN);
      }
      return response;
    } catch (e) {
      toast.error(e.message);
    }
  };



export const ac_resend_code =
  (userName) => async (dispatch: any, getState: any) => {
    try {
      const response: any = await resend_verification(
        userName ? userName.toLowerCase() : userName
      );
      toast("Code has been resent to your email");
      return response;
    } catch (e) {
      toast.error(e.message);
    }
  };

export const ac_signOut = () => async (dispatch: any, getState: any) => {
  try {
    await signOut();
    if (process.env.REACT_APP_AUTH_MODE !== "cognito") {
      navigationService.replace(URL_PATHS.LOGIN);
    } else {
      window.location.href = process.env.REACT_APP_AUTH_URL;
    }
    dispatch({
      type: Const.UN_AUTHORISE,
      payload: {},
    });
    dispatch({
      type: Const.APP_LOADING,
      payload: false,
    });
  } catch (e) {
    toast.error(e.message);
    dispatch({
      type: Const.APP_LOADING,
      payload: false,
    });
  }
};

export const ac_autoLogIn = () => async (dispatch: any, getState: any) => {
  try {
    dispatch(ac_app_loading(true));
    const userInfo: any = await autoLogIn();
    dispatch(ac_get_account());
    dispatch({
      type: !userInfo ? Const.UN_AUTHORISE : Const.AUTHORISE,
      payload: userInfo,
    });
    dispatch(ac_app_loading(false));
  } catch (e) {
    dispatch({ type: Const.UN_AUTHORISE, payload: {} });
    dispatch(ac_app_loading(false));
    // A missing/expired session on first visit is a normal signed-out state.
    if (process.env.REACT_APP_AUTH_MODE === "cognito") toast.error(e.message);
  }
};

export const ac_forgot_password =
  (userName: string, migrationRequired = false) => async (dispatch: any, getState: any) => {
    try {
      await forgotPassword(userName ? userName.toLowerCase() : userName);
      toast("If your account is eligible, a verification code has been sent to your email.");
      navigationService.navigate("/reset-password", { userName, codeSent: true, migrationRequired });
    } catch (e) {
      toast.error(e.message);
      if (migrationRequired) {
        navigationService.navigate("/reset-password", { userName, codeSent: false, migrationRequired });
      }
    }
  };

export const ac_forgot_password_submit =
  (userName: string, resetCode: string, newPassword: string) =>
  async (dispatch: any, getState: any) => {
    try {
      const response: any = await forgotPasswordSubmit(
        userName,
        resetCode,
        newPassword
      );
      toast("Password changed successfully");
      if (process.env.REACT_APP_AUTH_MODE !== "cognito") {
        navigationService.navigate(URL_PATHS.LOGIN);
      } else if (response) {
        dispatch(ac_login(userName, newPassword));
        // Redirect to home/course after successful password reset and login
        navigationService.navigate("/");
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

export const ac_change_password =
  (oldPassword: string, newPassword: string) =>
  async (dispatch: any, getState: any) => {
    progressAction(async () => {
      try {
        const response: any = await changePassword(oldPassword, newPassword);
        if (process.env.REACT_APP_AUTH_MODE !== "cognito") {
          dispatch({ type: Const.UN_AUTHORISE, payload: {} });
          navigationService.navigate(URL_PATHS.LOGIN);
        }
        toast("Password changed successfully");
        return response;
      } catch (e) {
        toast.error(e.message);
      }
    });
  };

export const ac_new_password =
  (password: string, userSession: any) =>
  async (dispatch: any, getState: any) => {
    progressAction(async () => {
      try {
        const response: any = await newPassword(password, userSession);
        toast("Password changed successfully");
        window.location.reload();
      } catch (e) {
        toast.error(e.message);
      }
    });
  };
